module.exports = __webpack_public_path__ + "img/warehouse-full.22eb6c96.svg";